import { isDefined } from "@clipboard-health/util-ts";
import { useFormContext } from "react-hook-form";

import { SingleSelectQuestion } from "../components/SingleSelectQuestion";
import { SurveyStepLayout } from "../components/SurveyStepLayout";
import { type ScreeningSurveyFormData } from "../lib/screeningSurveySchema";
import {
  hospiceExperienceLevelLabels,
  hospiceExperienceLevelValues,
} from "../lib/screeningSurveyTypes";

const options = hospiceExperienceLevelValues.map((value) => ({
  value,
  label: hospiceExperienceLevelLabels[value],
}));

interface HospiceExperienceStepProps {
  onContinue: () => void;
  onBack: () => void;
  currentStep: number;
  totalSteps: number;
}

export function HospiceExperienceStep(props: HospiceExperienceStepProps) {
  const { onContinue, onBack, currentStep, totalSteps } = props;
  const { watch, setValue } = useFormContext<ScreeningSurveyFormData>();
  const value = watch("hospiceExperience");

  return (
    <SurveyStepLayout
      currentStep={currentStep}
      totalSteps={totalSteps}
      title="How many years of Hospice experience do you have?"
      continueDisabled={!isDefined(value)}
      onBack={onBack}
      onContinue={onContinue}
    >
      <SingleSelectQuestion
        options={options}
        value={value}
        onChange={(v) => {
          setValue("hospiceExperience", v);
        }}
      />
    </SurveyStepLayout>
  );
}
